<template>
  <widget-content
    class="activity-widget"
    :class="$store.getters.isMobile ? 'activity_content_mobile relative' : 'activity_content_desk relative'"
    :bg="model.background"
    :mobile-bg="model.mobileBackground"
  >
    <rich-text
      v-model="model.title"
      :editing="editing"
      :stroke.sync="model.titleStroke"
      :disabled="!editing"
      placement="top"
      theme="snow"
      class="w-full activity_title relative"
    />
    <row-content v-if="model.layout === AccumulationLayoutEnum.Row" :model="model" :type="AccumulationLayoutEnum.Row" :editing="editing" :is-mobile="$store.getters.isMobile" @show-detail="onItemClick" />
    <col-content v-else-if="model.layout === AccumulationLayoutEnum.Col" :model="model" :editing="editing" :type="AccumulationLayoutEnum.Col" :is-mobile="$store.getters.isMobile" @show-detail="onItemClick" />
    <rich-text
      v-if="model.subtitleVisible"
      v-model="model.subtitle"
      :stroke.sync="model.subTitleStroke"
      :editing="editing"
      :disabled="!editing"
      placement="top"
      theme="snow"
      class="w-full activity_desc relative"
    />
    <info-detail ref="info" :data="currentRow" :is-mobile="$store.getters.isMobile"/>
  </widget-content>
</template>

<script>
import RowContent from './rowContent.vue'
import ColContent from './colContent.vue'
import InfoDetail from './info.vue'
import WidgetContent from '~/site/components/widgetContent'
import richText from '~/components/richText'
import { AccumulationLayoutEnum } from '~/enums/data'

export default {
  name: 'ActivityWidgetEdit',
  components: {
    InfoDetail,
    richText,
    WidgetContent,
    RowContent,
    ColContent
  },
  props: {
    model: {
      type: Object,
      default() {
        return {}
      },
    },
    editing: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      AccumulationLayoutEnum,
      currentRow: {}
    }
  },
  methods: {
    onItemClick(data) {
      this.currentRow = data
      this.$refs.info.init()
    }
  }
}
</script>

<style lang="less">
.activity-widget > div:last-child {
  max-width: 1040px;
  .activity_desc {
    margin-top: 20px;
  }
}
.activity_content_desk {
  padding: 60px 0 40px 0;
}

.activity_content_mobile {
  padding: 40px 15px 40px 15px;
}
</style>
